module.exports = __webpack_public_path__ + "static/media/copy.87b96b6f.svg";